// src/components/PromptManagement/PromptAdminClient.ts

import * as proto from '@safeguardproperties/proto/lambda/ml/promptadmin/v1/promptadmin_v1_pb';
import ServiceClient from './serviceClient';

export class PromptAdminClient extends ServiceClient {
  constructor(baseUrl: string, debug: boolean) {
    super(baseUrl, debug);
  }

  public async Export(
    request: proto.PromptAdminExportRequest
  ): Promise<proto.PromptAdminExportResponse> {
    return this.Post('export', request, proto.PromptAdminExportResponse);
  }

  public async Import(
    request: proto.PromptAdminImportRequest
  ): Promise<proto.PromptAdminImportResponse> {
    return this.Post('import', request, proto.PromptAdminImportResponse);
  }
}
